/** @format */

import React from 'react';
import DateRange from './date_range';

export default class extends React.Component {
    /**
     * Need to have an initial empty value for the filters
     * @returns {{value: string}}
     */
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    /**
     * On mount, focus our search filter box
     */
    componentDidMount() {
        this.refs.searchFilterInputBox.focus();
    }

    /**
     * Allow the user to click anywhere but children to close
     * https://gist.github.com/pstoica/4323d3e6e37e8a23dd59
     * http://stackoverflow.com/questions/11592966/get-the-newly-focussed-element-if-any-from-the-onblur-event/11592974#11592974
     * @param e
     */
    onBlur = e => {
        const target = e.currentTarget;

        setTimeout(
            function () {
                // Make sure we are not clicking one of my children
                if (!target.contains(document.activeElement)) {
                    this.props.onCancel();
                }
            }.bind(this),
            0
        );
    };

    /**
     * If the user hits enter we want to save it
     * @param e
     */
    handleEnter = e => {
        if (e.charCode == 13) {
            this.props.onSave(this._filter());
            this.props.onCancel();
        }
    };

    /**
     * if the save button is clicked
     */
    handleSave = () => {
        this.props.onSave(this._filter());
        this.props.onCancel();
    };

    handleSelect = e => {
        var option = e.currentTarget.dataset.option;
        var filter = this.props.filter;
        filter.value = option;

        this.setState({value: option});
        this.props.onSave(filter);
        this.props.onCancel();
    };

    handleDateRange = value => {
        this.setState({value: value});
    };

    /**
     * typitty type type stuff
     */
    handleChange = () => {
        var value = this.refs.filter_option_input.value;
        this.setState({value: value});
    };

    sort = (a, b) => {
        let aName, bName;
        if (typeof a.sort != 'undefined' && typeof b.sort != 'undefined') {
            aName = a.sort;
            bName = b.sort;
        } else {
            aName = a.name.toLowerCase();
            bName = b.name.toLowerCase();
        }

        if (aName < bName) return -1;
        if (aName > bName) return 1;
        return 0;
    };

    render() {
        return (
            <div
                tabIndex="0"
                className="search__filter-box"
                ref="searchFilterInputBox"
                onBlur={this.onBlur}>
                <div className="filter-box__list bg-dark text-white">{this._input()}</div>
            </div>
        );
    }

    _input = () => {
        if (this.props.filter.type == 'select') {
            return this._select();
        } else if (this.props.filter.type == 'date_range') {
            return this._dateRange();
        }

        return this._text();
    };

    _text = () => {
        return (
            <div className="filters-subfilter">
                <div>
                    <div className="p-2 text-nowrap">
                        Filter By {this.props.filter.name} - Enter Text
                    </div>
                </div>
                <div className="tw-flex tw-p-1 bg-lighter tw-items-center filters-subfilter__inputgroup">
                    <span
                        className="text-nowrap filters-subfilter__name"
                        style={{fontSize: '16px'}}>
                        {this.props.filter.name + '='}
                    </span>
                    <input
                        style={{width: '125px'}}
                        className="tw-text-gray-900 tw-px-2 tw-text-md form-control form-control-sm"
                        autoFocus={true}
                        ref="filter_option_input"
                        onKeyPress={this.handleEnter}
                        onChange={this.handleChange}
                        type="text"
                        value={this.state.value}
                        name="filter_text"
                    />
                    <button
                        onClick={this.handleSave}
                        className="btn btn-secondary text-nowrap btn-sm">
                        Add Filter
                    </button>
                </div>
            </div>
        );
    };

    _select = () => {
        return (
            <div className="filters-subfilter">
                <div className="bg-gray-lighter">
                    <div className="p-2 text-nowrap">
                        Filter By {this.props.filter.name} - Choose One
                    </div>
                </div>
                <div className="filter-box__filters">
                    {this.props.filter.options.sort(this.sort).map(option => {
                        return (
                            <button
                                key={'option_' + option.id}
                                style={{border: 'solid 1px #FFF'}}
                                className="btn btn-secondary w-100"
                                onClick={this.handleSelect}
                                data-option={option.id}>
                                {option.name}
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    };

    _dateRange = () => {
        return (
            <div className="filters-subfilter">
                <div className="bg-gray-lighter">
                    <div className="p-2 text-nowrap">Filter By {this.props.filter.name}</div>
                </div>
                <div className="filter-box__filters">
                    <DateRange
                        name={this.props.filter.name}
                        value={this.state.value}
                        intervals={this.props.filter.intervals}
                        onChange={this.handleDateRange}
                        onSave={this.handleSave}
                        onCancel={this.props.onCancel}
                    />
                </div>
            </div>
        );
    };

    _filter = () => {
        var filter = this.props.filter;
        filter.value = this.state.value;
        return filter;
    };
}
